import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import * as loaders from '../loader';
import AIChatWindow from '../components/ai-chat-window';

const VChart = lazy(async () => {
  const { VChart } = await import('../sites/vchart');
  return { default: VChart };
});
const VChartExample = lazy(async () => {
  const { Example } = await import('../sites/vchart/views/example');
  return { default: Example };
});
const VChartDemo = lazy(async () => {
  const { Demo } = await import('../sites/vchart/views/demo');
  return { default: Demo };
});
const VChartExampleReact = lazy(async () => {
  const { Example } = await import('../sites/vchart/views/example-react');
  return { default: Example };
});
const VChartDemoReact = lazy(async () => {
  const { Demo } = await import('../sites/vchart/views/demo-react');
  return { default: Demo };
});
const VChartExampleOpeninula = lazy(async () => {
  const { Example } = await import('../sites/vchart/views/example-openinula');
  return { default: Example };
});
const VChartDemoOpeninula = lazy(async () => {
  const { Demo } = await import('../sites/vchart/views/demo-openinula');
  return { default: Demo };
});
const VChartOption = lazy(async () => {
  const { Option } = await import('../sites/vchart/views/option');
  return { default: Option };
});
const VChartGuide = lazy(async () => {
  const { Guide } = await import('../sites/vchart/views/guide');
  return { default: Guide };
});

const VChartContributing = lazy(async () => {
  const { Contributing } = await import('../sites/vchart/views/contributing');
  return { default: Contributing };
});

const VChartAPI = lazy(async () => {
  const { API } = await import('../sites/vchart/views/api');
  return { default: API };
});
const VChartFAQ = lazy(async () => {
  const { FAQ } = await import('../sites/vchart/views/faq');
  return { default: FAQ };
});
const VChartTheme = lazy(async () => {
  const { Theme } = await import('../sites/vchart/views/theme');
  return { default: Theme };
});
const VChartChangelog = lazy(async () => {
  const { Changelog } = await import('../sites/vchart/views/changelog');
  return { default: Changelog };
});
const VChartBundle = lazy(async () => {
  const { Bundle } = await import('../sites/vchart/views/bundle');
  return { default: Bundle };
});
const VChartPlayground = lazy(async () => {
  const { Playground } = await import('../sites/vchart/views/playground');
  return { default: Playground };
});
const VChartPage = lazy(async () => {
  const { ChartPage } = await import('../sites/vchart/views/chartpage');
  return { default: ChartPage };
});
const VChartEntry = lazy(async () => {
  const { Entry } = await import('../sites/vchart/views/entry');
  return { default: Entry };
});

export const vchartRoutes: RouteObject[] = [
  {
    path: '/vchart',
    element: (
      <Suspense>
        <VChart />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
  },
  {
    path: '/vchart/example',
    shouldRevalidate: () => true,
    loader: loaders.exampleLoader,
    element: (
      <Suspense>
        <VChartExample />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
  },
  {
    path: '/vchart/demo',
    shouldRevalidate: () => true,
    loader: loaders.demoLoader,
    element: (
      <Suspense>
        <VChartDemo />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VChartDemo />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vchart/example-react',
    shouldRevalidate: () => true,
    loader: loaders.exampleLoader,
    element: (
      <Suspense>
        <VChartExampleReact />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
  },
  {
    path: '/vchart/demo-react',
    shouldRevalidate: () => true,
    loader: loaders.demoLoader,
    element: (
      <Suspense>
        <VChartDemoReact />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VChartDemoReact />
            {/* <AIChatWindow /> */}
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vchart/example-openinula',
    shouldRevalidate: () => true,
    loader: loaders.exampleLoader,
    element: (
      <Suspense>
        <VChartExampleOpeninula />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
  },
  {
    path: '/vchart/demo-openinula',
    shouldRevalidate: () => true,
    loader: loaders.demoLoader,
    element: (
      <Suspense>
        <VChartDemoOpeninula />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VChartDemoOpeninula />
            {/* <AIChatWindow /> */}
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vchart/guide',
    loader: loaders.guideLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VChartGuide />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VChartGuide />
            {/* <AIChatWindow /> */}
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vchart/contributing',
    loader: loaders.contributingLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VChartContributing />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VChartContributing />
            {/* <AIChatWindow /> */}
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vchart/option',
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VChartOption />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VChartOption />
            {/* <AIChatWindow /> */}
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vchart/api',
    loader: loaders.apiLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VChartAPI />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VChartAPI />
            {/* <AIChatWindow /> */}
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vchart/faq',
    loader: loaders.faqLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VChartFAQ />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VChartFAQ />
            {/* <AIChatWindow /> */}
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vchart/theme',
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VChartTheme />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VChartTheme />
            {/* <AIChatWindow /> */}
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vchart/changelog',
    loader: loaders.changelogLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VChartChangelog />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VChartChangelog />
            {/* <AIChatWindow /> */}
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vchart/bundle',
    element: (
      <Suspense>
        <VChartBundle />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
    children: [
      {
        path: '*',
        element: (
          <Suspense>
            <VChartBundle />
            {/* <AIChatWindow /> */}
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/vchart/playground',
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VChartPlayground />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
  },
  {
    path: '/vchart/chartpage',
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VChartPage />
      </Suspense>
    ),
  },
  {
    path: '/vchart/entry',
    loader: loaders.entryLoader,
    shouldRevalidate: () => true,
    element: (
      <Suspense>
        <VChartEntry />
        {/* <AIChatWindow /> */}
      </Suspense>
    ),
  },
];
